package games.polyclub.website.frontend.store.context

import games.polyclub.frontend.lib.messagerenderer.Viewer
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.message.BuildString
import games.polyclub.message.Message
import games.polyclub.message.unaryMinus
import js.core.jso
import react.PropsWithChildren
import react.createContext
import react.router.useLocation
import react.useEffect
import react.useState
import web.dom.document

external interface BreadcrumbsContextData {
    var render: Int
    var pathString: String
    var path: List<String>
    var names: List<Pair<String, Message>>
    var lastName: Message
    var add: (String, Message) -> Unit
}

val BreadcrumbsContext = createContext<BreadcrumbsContextData>()

val BreadcrumbsProvider = SFC<PropsWithChildren> { props ->
    val (path, setPath) = useState(emptyList<Pair<String, Message>>())
    val (renderId, setRenderId) = useState(0)
    val location = useLocation()
    useEffect(location) {
        setPath(emptyList())
        setRenderId { it + 1 }
    }

    useEffect(path) {
        document.title = if(path.isEmpty()) "Loja GameMods" else path.asReversed().joinToString(" | ", postfix = " | Loja GameMods") { (_, title) ->
            title - BuildString(Viewer)
        }
    }

    BreadcrumbsContext.Provider {
        value = jso {
            this.render = renderId
            this.path = path.map { it.first }
            this.pathString = if(this.path.isEmpty()) "" else this.path.joinToString("/", prefix = "/")
            this.names = path.fold(mutableListOf("" to -"")) { acc, pair ->
                acc += "${acc.last().first}/${pair.first}" to pair.second
                acc
            }.apply { removeFirst() }
            this.lastName = this.names.lastOrNull()?.second ?: -"Página Inicial"
            this.add = { segmentPath, segmentName ->
                setPath { current ->
                    current + (segmentPath to segmentName)
                }
            }
        }
        +props.children
    }
}

fun useBreadcrumbs() = checkNotNull(react.useContext(BreadcrumbsContext)) {
    "BreadcrumbsContext indisponível"
}

fun addBreadcrumb(path: String, name: Message) {
    val breadcrumbs = useBreadcrumbs()
    useEffect(breadcrumbs.render) {
        breadcrumbs.add(path, name)
    }
}
